import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPhone = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4 10C4 6.47671 6.61863 3.50236 10.1202 3.05489C11.0031 2.94805 11.8502 3.43795 12.1979 4.25644L14.7079 10.1132C14.9718 10.7289 14.9099 11.4358 14.5431 11.9963L12.463 15.173L12.62 15.479C13.5148 17.1479 14.8859 18.513 16.5534 19.3976L16.865 19.555L19.9945 17.4686C20.51 17.1248 21.1527 17.0411 21.7348 17.2346L21.8919 17.2943L27.7435 19.8022C28.5621 20.1498 29.052 20.9969 28.9443 21.8864C28.4977 25.3814 25.5233 28 22 28C12.0589 28 4 19.9411 4 10ZM10.358 5.04002L10.1419 5.07352C7.75891 5.48776 6 7.55955 6 10C6 18.8366 13.1634 26 22 26C24.5167 26 26.6414 24.1295 26.9597 21.6414L21.104 19.1326L17.9791 21.2163C17.396 21.6098 16.6486 21.6663 16.0059 21.3617C13.679 20.2366 11.7969 18.3631 10.6579 16.0344C10.3549 15.4027 10.4062 14.6582 10.7901 14.0785L12.8696 10.9011L10.358 5.04002Z"
	})
});
export default SvgPhone;
